import React from 'react';
import { Container } from './styled';

interface BlockInfoProps {
  text: string;
  cypress: string;
}
export const BlockInfo: React.FC<BlockInfoProps> = ({ text, cypress }) => (
  <Container tag="body_3" data-cy={cypress}>
    {text}
  </Container>
);
